import { render, staticRenderFns } from "./dividende_update.vue?vue&type=template&id=62265b4d&"
import script from "./dividende_update.vue?vue&type=script&lang=js&"
export * from "./dividende_update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports